<template>
  <mi-dialog
    :model-value="modelValue"
    :custom-design-dialog="true"
    class="send-to-search-change-pm-dialog"
    no-backdrop-dismiss
  >
    <div class="send-to-search-change-pm-dialog-wrapper">
      <div class="send-to-search-change-pm-header-wrapper">
        <div class="send-to-search-change-pm-btn">
          <h3 class="q-mt-none q-mb-none"> Select a different product model </h3>
          <div>
            <mi-btn
              icon="close"
              icon-type
              icon-size="21px"
              fab
              flat
              @click="resetAndCloseModal"
            ></mi-btn>
          </div>
        </div>
      </div>

      <div>
        <mi-td>
          <div class="change-pm-wrapper">
            <mi-select
              v-model="selectedProductModel"
              :options="productModels"
              :display-value="selectedProductModel?.businessName"
              class="q-mb-sm"
              :class="isUnavailableProductModelSelected ?
                'select-pm-dropdown-unavailable': ''"
              label="Product Model"
              option-label="businessName"
              options-selected-class="text-accent"
              :outlined="!isUnavailableProductModelSelected"
              :lazy-rules="false"
              hide-bottom-space
            ></mi-select>
          </div>
          <p v-if="isUnavailableProductModelSelected" class="text-pm-unavailable">User export not available.</p>
        </mi-td>
      </div>

      <div class="send-to-search-change-pm-wrapper">
        <mi-btn flat @click="resetAndCloseModal"> Cancel </mi-btn>
        <mi-btn
          :disable="isUnavailableProductModelSelected"
          @click="openSendToSearchModal(selectedProductModel)"
        >
          Confirm
        </mi-btn>
      </div>
    </div>
  </mi-dialog>
</template>

<script>
  import { computed, ref } from 'vue'

  export default {
    name: 'ChangePmConfirmation',
    props: {
      modelValue: {
        type: Boolean,
        default: false
      },
      productModels: {
        type: Array,
        default: () => []
      },
      handleChangePmModalOpen: {
        type: Function,
        default: () => {}
      },
      unavailableProductModel: {
        type: Object,
        required: true,
        default: () => {}
      },
      openSendToSearchModal: {
        type: Function,
        default: () => {}
      }
    },
    emits: ['update:changePmModal', 'confirm'],
    setup(props) {
      const selectedProductModel = ref(props.unavailableProductModel)
      const isUnavailableProductModelSelected = computed((
      ) => selectedProductModel.value.id === props.unavailableProductModel.productModelID)

      const resetAndCloseModal = () => {
        selectedProductModel.value = props.unavailableProductModel
        props.handleChangePmModalOpen()
      }

      return {
        selectedProductModel,
        isUnavailableProductModelSelected,
        resetAndCloseModal
      }
    }
  }
</script>

<style lang="scss" scoped>
  .send-to-search-change-pm-dialog {
    width: 475px;
    height: 280px;
  }

  .send-to-search-change-pm-header {
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
  }

  .send-to-search-change-pm-wrapper {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }

  .send-to-search-change-pm-dialog-wrapper {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .send-to-search-change-pm-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  ::v-deep(.select-pm-dropdown-unavailable .q-field__control) {
    border: solid 2px $mi-red-800;
  }

  .text-pm-unavailable {
    font-family: $mi-typography-font-family;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    color: $mi-red-800;
  }

  .change-pm-wrapper {
    width: 427px;
  }
</style>
